<template>
	<div class="flex items-center gap-2">
		<component
			:is="variant.icon"
			v-if="status"
		/>
		<span class="text-[12px] leading-[14.5px] whitespace-nowrap">
			{{ variant?.text || '' }}
		</span>
	</div>
</template>

<script setup>
import { toRefs, computed } from 'vue';

// icons
import SuccessEvaluation from '../../icons/resume-scorer/evaluation-success.vue';
import PartialyEvaluation from '../../icons/resume-scorer/evaluation-partialy.vue';
import FailEvaluation from '../../icons/resume-scorer/evaluation-fail.vue';

const props = defineProps({
	status: {
		type: String,
		default: null
	}
});

const { status } = toRefs(props);

const evaluationOptions = {
	fullyMet: {
		icon: SuccessEvaluation,
		text: 'Fully Met'
	},
	partiallyMet: {
		icon: PartialyEvaluation,
		text: 'Partially Met'
	},
	notMet: {
		icon: FailEvaluation,
		text: 'Not Met'
	}
};

const variant = computed(() => {
	return evaluationOptions[status.value];
});
</script>